import Base from 'app/views/base';

import CarrierTypeListItemView from 'app/components/pages/carrier_accounts/add_carrier_account/item';

import tmpl from './list_template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize({ carrierAccounts }) {
    this.carrierAccounts = carrierAccounts;
    this.listenTo(this.collection, 'sync filtered', this.render);
  },

  beforeRender() {
    this.removeSubviews();

    this.collection.filtered().forEach(type => {
      this.addSubview(`ct_${type.get('type')}`, `#ct_${type.get('type')}`, new CarrierTypeListItemView({
        model: type,
        carrierAccounts: this.carrierAccounts,
      }));
    });
  },

  context() {
    return { carrierTypes: this.collection.filtered() };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/carrier_accounts/add_carrier_account/list.js